// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__bJApp","buttons":"SendReceipts_buttons__3jH7W","email":"SendReceipts_email__2RTlr","bookApptTitle":"SendReceipts_bookApptTitle__1HD1k"};